import { render } from "./AtomSwitchCustom.vue?vue&type=template&id=37ebef90"
import script from "./AtomSwitchCustom.vue?vue&type=script&lang=js"
export * from "./AtomSwitchCustom.vue?vue&type=script&lang=js"

import "./AtomSwitchCustom.vue?vue&type=style&index=0&id=37ebef90&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__